const question = {
    lessThan: { point: [1] },
    between: { point: [2] },
    moreThan: { point: [3] },
};

export default question;
